import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { Entry } from 'contentful'
import { RootState } from '~/types/store'

interface LevelFields {
  title: string
  slug: string
  [key: string]: unknown
}

interface ParsedLevel {
  title: string
  slug: string
  id: string
}

export interface LevelsState {
  levels: Entry<LevelFields>[]
  selectedLevels: string[]
}

export function state (): LevelsState {
  return ({
  levels: [],
  selectedLevels: []
})
}

export const mutations: MutationTree<LevelsState> = {
  SET_LEVELS (state, data: Entry<LevelFields>[]) {
    state.levels = data
  },
  SET_SELECTED_LEVEL (state, level: string) {
    if (state.selectedLevels.includes(level)) {
      state.selectedLevels.splice(state.selectedLevels.indexOf(level), 1)
    } else {
      state.selectedLevels.push(level)
    }
  },
  SET_SELECTED_LEVELS (state, levels: string[]) {
    state.selectedLevels = levels
  }
}

export const getters: GetterTree<LevelsState, RootState> = {
  parsedLevels (state): ParsedLevel[] {
    if (!state.levels.length) return []
    return state.levels.map((level) => {
      return {
        title: level.fields.title,
        slug: level.fields.slug,
        id: level.sys.id
      }
    })
  },
  filteredLevels (state, getters): ParsedLevel[] {
    if (!getters.parsedLevels.length) return []
    const sortingArray = ['VMBO', 'HAVO', 'VWO']
    const filtered = (getters.parsedLevels as ParsedLevel[]).filter(level => sortingArray.includes(level.title))
    const sorted = filtered.sort(function (a, b) {
      return sortingArray.indexOf(a.title) - sortingArray.indexOf(b.title)
    })
    return sorted
  },
  levelOptions (state, getters) {
    if (!state.selectedLevels.length) return null
    const selected = (getters.parsedLevels as ParsedLevel[]).filter((level) => {
      const exactMatch = state.selectedLevels.includes(level.title)
      const VMBO = state.selectedLevels.includes('VMBO') && level.title.includes('VMBO')
      return exactMatch || VMBO
    })
    const ids = selected.map(level => level.id)
    return { 'fields.level.sys.id[in]': ids.join(',') }
  }
}

export const actions: ActionTree<LevelsState, RootState> = {
  async get ({ commit }) {
    const { items } = await this.$contentful.getEntries<LevelFields>({
      content_type: 'level',
      order: 'fields.title'
    })
    commit('SET_LEVELS', items)
  }
}
